import './underwriting.submission.detail.risk-profile.action.buttons.scss';

import { Box, Stack } from '@mui/material';
import {
  DeclineSubmissionButton,
  LostSubmissionButton,
  ReferredSubmissionButton,
  UndoLostSubmissionButton,
} from '../submission-action';
import { RaterMode, SubmissionStatus } from '@converge/graphql';

import AddIcon from '@mui/icons-material/Add';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import { DocumentButton } from '../submission-action/document-button';
import DownloadIcon from '@mui/icons-material/Download';
import { ISubmissionProps } from '../overview';
import { NewConvergeButton } from '../../../presentation/components';
import { ReopenSubmissionButton } from '../submission-action/reopen-submission-button';
import { UnderwritingSubmissionDetailPageSlug } from '@converge/data';
import config from '@converge/config';
import { useOutletContext } from 'react-router-dom';
import { useUnderwritingSubmissionDetailPage } from '../underwriting.submission.detail.hooks';
import { useUnderwritingSubmissionStateContext } from '../underwriting.submission.context';

interface IProps {
  submissionId: string;
  submissionStatus: string;
  submissionUuid: string;
}

export const UnderwritingSubmissionDetailRiskProfileActionButtons = ({
  submissionId,
  submissionUuid,
  submissionStatus,
}: IProps) => {
  const { navigate: navigatePage } = useUnderwritingSubmissionDetailPage();
  const {
    info: { allowCreatingQuotes },
  } = useUnderwritingSubmissionStateContext();
  const isShowLostButton =
    submissionStatus === SubmissionStatus.Closed ||
    submissionStatus === SubmissionStatus.Evaluation ||
    submissionStatus === SubmissionStatus.Quoted ||
    submissionStatus === SubmissionStatus.Referred ||
    submissionStatus === SubmissionStatus.Submitted;
  const { submission: submissionInfo } = useOutletContext<ISubmissionProps>();
  return (
    <Stack className="bind-footer">
      {config.featureFlags.showRiskProfileCreateQuoteOptionButton &&
        allowCreatingQuotes && (
          <NewConvergeButton
            label="Create quote option"
            startIcon={<AddIcon />}
            onClick={() => {
              navigatePage.page({
                sectionUrl: `${UnderwritingSubmissionDetailPageSlug.Quote}/${RaterMode.CreateQuote}`,
              });
            }}
          />
        )}

      {config.featureFlags.showRiskProfileRiskReportButton && (
        <NewConvergeButton
          label="Risk report"
          startIcon={<DownloadIcon />}
          onClick={() => {
            navigatePage.page({
              sectionUrl: `risk-profile/risk-report`,
            });
          }}
        />
      )}
      {config.featureFlags.showRiskProfileRequestInfoButton && (
        <Box className="button-box">
          <NewConvergeButton
            label="Request info"
            startIcon={<AnnouncementIcon />}
            onClick={() => {
              console.log(
                'Request Info button clicked. FUNCTIONALITY NOT IMPLEMENTED YET'
              );
            }}
          />
        </Box>
      )}
      {submissionStatus === SubmissionStatus.Closed && (
        // eslint-disable-next-line react/jsx-no-undef
        <Box className="button-box">
          <ReopenSubmissionButton
            referenceId={submissionId}
            submissionId={submissionUuid}
          />
        </Box>
      )}
      <Box className="button-box">
        <DeclineSubmissionButton
          referenceId={submissionId}
          submissionId={submissionUuid}
        />
      </Box>

      {isShowLostButton && (
        <Box className="button-box">
          <LostSubmissionButton
            referenceId={submissionId}
            submissionId={submissionUuid}
          />
        </Box>
      )}
      {submissionStatus === SubmissionStatus.Lost && (
        <Box className="button-box">
          <UndoLostSubmissionButton
            referenceId={submissionId}
            submissionId={submissionUuid}
          />
        </Box>
      )}
      <Box className="button-box">
        <ReferredSubmissionButton
          referenceId={submissionId}
          submissionId={submissionUuid}
        />
      </Box>
      {submissionInfo?.documentLink && (
        <Box className="button-box">
          <DocumentButton
            submissionDocumentLink={submissionInfo.documentLink}
          />
        </Box>
      )}
    </Stack>
  );
};
